/* eslint-disable no-undef */
/* eslint-disable new-cap */
import { connect } from 'react-redux';

import AddUserForm from './AddUserForm.component';

/** @namespace Pwa/Component/AddUserForm/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    companyRoles: state.CompanyRolesReducer.companyRoles
});

/** @namespace Pwa/Component/AddUserForm/Container/mapDispatchToProps */
// eslint-disable-next-line no-unused-vars
export const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AddUserForm);
